import { Button as ShadcnButton } from "app/shadcnComponents/ui/button";
import { cn } from "app/lib/utils";

interface Pill {
  label: string;
  count: number;
  dotClass: string;
  targetId: string;
  dimmed?: boolean;
}

export default function JumpPills({ pills }: Readonly<{ pills: Pill[] }>) {
  const handleClick = (targetId: string) => {
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="flex gap-1.5 px-6 py-2.5 flex-wrap">
      {pills.map((pill) => (
        <ShadcnButton
          key={pill.targetId}
          variant="secondary-gray"
          size="sm"
          className={cn(
            "rounded-full gap-1.5",
            pill.dimmed && "text-charcoal-60 opacity-70"
          )}
          onClick={() => handleClick(pill.targetId)}
        >
          <span className={cn("w-1.5 h-1.5 rounded-full", pill.dotClass)} />
          {pill.label} <span className="font-semibold">{pill.count}</span>
        </ShadcnButton>
      ))}
    </div>
  );
}
